import React from 'react';
import { Link } from 'react-router-dom';

const projects = [
  { id: 'mapnitor', title: 'Mapnitor', category: 'Product Design / Analytics', img: '/assets/mapnitor.png', tag: '01' },
  { id: 'blogator', title: 'Blogator', category: 'Web App / AI Content', img: '/assets/blogator.png', tag: '02' },
  { id: 'tinyfocus', title: 'TinyFocus', category: 'Web Design / Productivity', img: '/assets/tinyfocus.png', tag: '03' }
];

export default function Projects() {
  return (
    <section className="pt-32 pb-32 px-6 min-h-screen" style={{ background: '#082318' }}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-16" style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '2.5rem' }}>
          <p className="text-sm font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: '#d4f542' }}>Portfolio</p>
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-white mb-5">
            Selected Works
          </h1>
          <p className="text-lg max-w-2xl leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
            Dive into our latest case studies. We build digital products that combine beautiful aesthetics with engineered performance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 gap-y-14">
          {projects.map((project, i) => (
            <Link
              to={`/projects/${project.id}`}
              key={project.id}
              className={`group cursor-pointer block ${i === 2 ? 'md:col-span-2' : ''}`}
            >
              <div
                className={`overflow-hidden rounded-2xl flex items-center justify-center ${i === 2 ? 'aspect-[21/9]' : 'aspect-[4/3]'}`}
                style={{ background: '#0e3322', border: '1px solid rgba(255,255,255,0.07)' }}
              >
                <img
                  src={project.img}
                  alt={project.title}
                  onError={e => { e.target.src = 'https://images.unsplash.com/photo-1611162616475-46b635cb6868?q=80&w=1600&auto=format&fit=crop'; }}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="mt-5 flex justify-between items-start">
                <div>
                  <span className="text-xs font-mono uppercase tracking-widest mb-1 block" style={{ color: '#d4f542' }}>{project.tag}</span>
                  <h3 className="text-xl font-semibold text-white group-hover:opacity-70 transition">{project.title}</h3>
                </div>
                <p className="text-sm font-mono tracking-tight" style={{ color: 'rgba(255,255,255,0.4)' }}>{project.category}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

